import { mediaKeys } from "../hooks/useMedia.mjs";
import { pseudoDescriptors } from "./pseudoDescriptors.mjs";
const mergeProps = (a, b, inverseShorthands) => {
  const out = {};
  for (const key in a) mergeProp(out, a, b, key, inverseShorthands);
  if (b) for (const key in b) mergeProp(out, b, void 0, key, inverseShorthands);
  if (b && Object.keys(b).length > 0 && Object.keys(b).some(key => (key in pseudoDescriptors || key === "variant") && key in a && key in out)) {
    const reordered = {};
    for (const key in b) (key in pseudoDescriptors || key === "variant") && key in out && (reordered[key] = out[key]);
    for (const key in out) key in reordered || (reordered[key] = out[key]);
    return reordered;
  }
  return out;
};
function mergeProp(out, a, b, key, inverseShorthands) {
  const longhand = inverseShorthands?.[key] || null,
    val = a[key];
  if (key in pseudoDescriptors || mediaKeys.has(key)) {
    out[key] = {
      ...out[key],
      ...val
    };
    return;
  }
  b && (key in b || longhand && longhand in b) || (out[longhand || key] = val);
}
export { mergeProps };
//# sourceMappingURL=mergeProps.mjs.map
